import * as React from "react";

interface IPersonnelSearchOtherProps {
    title?: string;
    update: (surname: string, firstName: string, institution: string) => void
}

interface IPersonnelSearchOtherState {
    surname?: string
    firstName?: string
    institution?: string
}

class PersonnelsSearchOther extends React.PureComponent<IPersonnelSearchOtherProps, IPersonnelSearchOtherState> {

    constructor(props: IPersonnelSearchOtherProps) {
        super(props);

        this.state = {
            surname: "",
            firstName: "",
            institution: ""
        };
    }
    
    updateState(): void {
        this.props.update(this.state.surname, this.state.firstName, this.state.institution)
    }
    
    render() {
        const {
            title,
            children
        } = this.props

        return <>{title ? <div className="col-md-12"><h3 className="mt-3">{title}</h3></div> : <></>}
            <div className="form-group row pt-0 pb-4 border border-bottom-1 border-top-0">
                <div className="col-md-6">
                    <div className="row bottom-0 border-top-0 pb-0 pt-4"><label
                        className="col-form-label col-sm-6">Surname</label>
                        <div className="col-sm-6 generic-form-field generic-form-field">
                            <input type="text" className="form-control" value={this.state.surname} onChange={(change) => this.setState({surname: change.target.value}, () => this.updateState()) } />
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="row bottom-0 border-top-0 pb-0 pt-4"><label
                        className="col-form-label col-sm-6">First name</label>
                        <div className="col-sm-6 generic-form-field generic-form-field">
                            <input type="text" className="form-control" value={this.state.firstName} onChange={(change) => this.setState({firstName: change.target.value}, () => this.updateState()) } />
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="row bottom-0 border-top-0 pb-0 pt-4"><label
                        className="col-form-label col-sm-6">Institution</label>
                        <div className="col-sm-6 generic-form-field generic-form-field">
                            <input type="text" className="form-control" value={this.state.institution} onChange={(change) => this.setState({institution: change.target.value}, () => this.updateState()) } />
                        </div>
                    </div>
                </div>
            </div>
        </>
    }
}

export default PersonnelsSearchOther;
